<div class="page">
  <div class="container">
    {{ "PAGE_NOT_FOUND_MESSAGE" | translate }}.
  </div>
</div>